/** Specification variables / Type-info variables */
export const fonts = {
  family: '',
  styles: {
    normal: '',
    itallic: ''
  },
  weights: {
    regular: '',
    medium: '',
    semiBold: '',
    bold: ''
  }
}
